/**
 * @class InputRadio
 * @classdesc Represents an input of type radio
 *
 * @extends Core.Component
 */
export default class InputRadio extends Core.Component {
  constructor(el, context) {
    super(el, context);

    this.inputEl = el.querySelector('[data-input]');

    // Get all radio inputs with same name and listen to their changes events
    // to sync this component
    // This is anti-pattern for a component but is acceptable because
    // all radio inputs with the same name inherently control each other
    const groupEls = document.querySelectorAll(`input[type="radio"][name="${this.inputEl.name}"]`);

    groupEls.forEach(groupEl => {
      this.events.register(groupEl, 'change', () => {
        if (this.inputEl.checked) {
          this.el.setAttribute('data-checked', '');
        } else {
          this.el.removeAttribute('data-checked');
        }
      });
    });
  }

  get value() {
    return this.inputEl.value;
  }

  get disabled() {
    return this.inputEl.disabled;
  }

  set disabled(disabled) {
    if (disabled) {
      this.el.setAttribute('data-disabled', '');
    } else {
      this.el.removeAttribute('data-disabled');
    }

    this.inputEl.disabled = disabled;
  }

  get checked() {
    return this.inputEl.checked;
  }

  set checked(checked) {
    if (checked) {
      this.el.setAttribute('data-checked', '');
    } else {
      this.el.removeAttribute('data-checked');
    }

    this.inputEl.checked = checked;
  }

  get unavailable() {
    return this.el.hasAttribute('data-unavailable');
  }

  set unavailable(unavailable) {
    if (unavailable) {
      this.el.setAttribute('data-unavailable', '');
    } else {
      this.el.removeAttribute('data-unavailable');
    }
  }
}
